import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2, AlertCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      return;
    }

    const validatePayment = async () => {
      try {
        await axios.get(`${BACKEND_URL}/api/payments/status/${sessionId}`);
        setStatus('success');
      } catch (error) {
        console.error("Payment validation failed:", error);
        setStatus('error'); 
      }
    };

    validatePayment();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 px-4">
      <div className="max-w-lg w-full bg-neutral-900 border border-white/10 p-8 rounded-2xl text-center shadow-2xl">
        
        {status === 'processing' && (
          <div className="space-y-6">
            <Loader2 className="w-16 h-16 text-purple-500 animate-spin mx-auto" />
            <h1 className="text-2xl font-bold text-white">Finalisation de votre commande...</h1>
            <p className="text-gray-400">Nous sécurisons votre réservation et envoyons vos emails.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-6 animate-in fade-in zoom-in duration-500">
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto text-green-500">
              <CheckCircle className="w-10 h-10" />
            </div>
            <h1 className="text-3xl font-bold text-white">Paiement Réussi !</h1>
            <p className="text-gray-300">
              Merci pour votre confiance. Vous avez reçu un email de confirmation avec tous les détails.
            </p>
            
            <div className="pt-4 space-y-3">
              <button 
                onClick={() => navigate('/dashboard')}
                className="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-xl transition-all"
              >
                Aller sur mon Espace Artiste
              </button>
              <button 
                onClick={() => navigate('/')}
                className="w-full py-3 bg-transparent border border-white/10 hover:bg-white/5 text-gray-400 font-medium rounded-xl transition-all"
              >
                Retour à l'accueil
              </button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-6">
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto text-red-500">
              <AlertCircle className="w-10 h-10" />
            </div>
            <h1 className="text-2xl font-bold text-white">Une petite erreur...</h1>
            <p className="text-gray-400">
              Votre paiement a peut-être fonctionné, mais nous n'avons pas pu afficher la confirmation. 
              Vérifiez vos emails ou votre Espace Artiste.
            </p>
            <button 
              onClick={() => navigate('/contact')}
              className="px-6 py-2 bg-white text-black rounded-full font-bold mt-4"
            >
              Contacter le support
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default PaymentSuccess;
